import { lighten } from "@mui/system";

const styles = (theme) => ({
	paper: {
		p: 2,
		mb: 2,
	},
	autocompleteServicos: {
		width: 300,
		mt: 2,
	},
	pagination: {
		marginTop: "auto",
		display: "flex",
		justifyContent: "center",
		mt: 2,
	},
	containerTextNoTicketsError: {
		position: "absolute",
		left: "45%",
		top: "45%",
		transform: "translateX(-50%)",
		"@media (max-width: 700px)": {
			left: "38%",
		},
		"@media (max-width: 600px)": {
			left: "40%",
			top: "20%",
		},
		"@media (max-width: 430px)": {
			left: "38%",
			top: "18%",
		},
	},
	containerNoTickets: {
		width: "100%",
		height: "100%",

		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		pt: 2,
	},
	switch: {
		width: 42,
		height: 26,
		padding: 0,
		"& .MuiSwitch-switchBase": {
			padding: 0,
			margin: 0.2,
			transitionDuration: "300ms",
			"&.Mui-checked": {
				transform: "translateX(16px)",
				color: "#fff",
				"& + .MuiSwitch-track": {
					backgroundColor: theme.palette.primary.main,
					opacity: 1,
					border: 0,
				},
				"&.Mui-disabled + .MuiSwitch-track": {
					opacity: 0.5,
				},
			},
			"&.Mui-focusVisible .MuiSwitch-thumb": {
				color: theme.palette.primary.main,
				border: "6px solid #fff",
			},
			"&.Mui-disabled .MuiSwitch-thumb": {
				color:
					theme.palette.mode === "dark"
						? theme.palette.grey[600]
						: theme.palette.grey[100],
			},
			"&.Mui-disabled + .MuiSwitch-track": {
				opacity: theme.palette.mode === "dark" ? 0.3 : 0.7,
			},
		},
		"& .MuiSwitch-thumb": {
			boxSizing: "border-box",
			width: 22,
			height: 22,
		},
		"& .MuiSwitch-track": {
			borderRadius: 26 / 2,
			backgroundColor:
				theme.palette.mode === "dark"
					? lighten(theme.palette.colors.black.dark, 0.4)
					: theme.palette.colors.gray.medium,
			opacity: 1,
			transition: theme.transitions.create(["background-color"], {
				duration: 500,
			}),
		},
	},
	textfield: {
		width: "100%",
		maxWidth: 300,
		fontSize: "0.75rem",
		"& .MuiInputBase-input": {
			padding: "8px 8px",
			fontSize: "0.75rem",
		},
		"& .MuiInputLabel-root": {
			fontSize: "0.75rem",
		},
	},
	boxButtonsHubsoft: {
		display: "flex",
		width: "100%",
		justifyContent: "space-between",
		alignItems: "center",
	},
});

export default styles;
